<template>
  <date-picker-dialog
    range
    v-bind:value="datePickerValue"
    v-on:input="onDatePickerDialogInput"
  >
    <template v-slot:trigger="{ listenerObject }">
      <fieldset class="day-month-range">
        <label
          class="day-month-range__date"
          title="Выбрать начальную дату"
        >
          {{ labelFrom }}
          <input
            class="day-month-range__input"
            required
            type="date"
            v-bind:value="valueFrom">
        </label>
        <span v-show="hasSelectedDate">—</span>
        <label
          class="day-month-range__date"
          title="Выбрать конечную дату"
        >
          {{ labelTo }}
          <input
            class="day-month-range__input"
            required
            type="date"
            v-bind:value="valueTo">
        </label>
        <button
          class="day-month-range__select"
          type="button"
          v-bind:title="hasSelectedDate ? 'Изменить период' : 'Выбрать период'"
          v-on="listenerObject"
        >{{ hasSelectedDate ? '' : 'Выберите период' }}</button>
      </fieldset>
    </template>
  </date-picker-dialog>
</template>
<script>
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import { convertToInputDate, formatDateToDayAndMonth } from '@/utils/timeFormat';

/**
 * @description Выбор периода дня и месяца.
 * @type {Vue}
 */
export default {
  components: {
    DatePickerDialog,
  },
  computed: {
    /**
     * @description Правая граница.
     */
    dateTo() {
      const [from, to] = this.datePickerValue;
      return to || from;
    },
    /**
     * @description Имеет выбранную дату.
     * @type {boolean}
     */
    hasSelectedDate() {
      return this.datePickerValue.length !== 0;
    },
    /**
     * @description Заголовок левой даты.
     */
    labelFrom() {
      return this.datePickerValue[0]
        ? formatDateToDayAndMonth(this.datePickerValue[0])
        : '';
    },
    /**
     * @description Заголовок правой даты.
     */
    labelTo() {
      return this.dateTo ? formatDateToDayAndMonth(this.dateTo) : '';
    },
    /**
     * @description Значение левой даты.
     */
    valueFrom() {
      return this.datePickerValue[0]
        ? convertToInputDate(this.datePickerValue[0])
        : '';
    },
    /**
     * @description Значение правой даты.
     */
    valueTo() {
      return this.dateTo ? convertToInputDate(this.dateTo) : '';
    },
  },
  data() {
    return {
      /**
       * @description Значение календаря.
       * @type {(Date[])}
       */
      datePickerValue: this.value,
    };
  },
  methods: {
    /**
     * @description Обработать ввод даты календаря.
     * @param {(Date[])} updatedValue Новые значения.
     * @returns {void}
     */
    onDatePickerDialogInput(updatedValue) {
      if (updatedValue.length === 2) {
        this.datePickerValue = (updatedValue.length === 2 ? updatedValue : [])
          .sort((first, second) => first.getTime() - second.getTime());
        this.$emit('input', this.datePickerValue.map(convertToInputDate));
      } else if (updatedValue.length === 1) {
        this.datePickerValue = updatedValue;
        this.$emit('input', [updatedValue[0], updatedValue[0]].map(convertToInputDate));
      } else {
        this.datePickerValue = [];
        this.$emit('input', []);
      }
    },
  },
  name: 'DayMonthRange',
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
  watch: {
    /**
     * @description Обработать изменение значения.
     */
    value(updatedValue) {
      if (updatedValue.length === 0) {
        this.datePickerValue = [];
      }
    },
  },
};
</script>
<style scoped>
.day-month-range {
  align-items: center;
  background: var(--primary-background-color);
  border-radius: var(--input-border-radius);
  border: 1px solid var(--border-color);
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  font-weight: 400;
  gap: .5rem;
  height: 2.5rem;
  line-height: 1.1875rem;
  padding: 0 0 0 .625rem;
  position: relative;
  width: 15.625rem;
}

.day-month-range:after {
  background-color: var(--fill-color);
  background-image: url("@/assets/img/calendar-grey.svg");
  background-position: center;
  border-radius: 0 4px 4px 0;
  content: '';
  height: 38px;
  overflow: hidden;
  position: absolute;
  right: 0;
  width: 38px;
}

.day-month-range .day-month-range__input {
  left: 0;
  opacity: 0;
  position: absolute;
  width: 0;
}

.day-month-range .day-month-range__select {
  height: inherit;
  left: 0;
  padding: inherit;
  position: absolute;
  text-align: inherit;
  width: inherit;
  z-index: 1;
}

@media screen and (max-width: 600px) {
  .day-month-range {
    flex-wrap: wrap;
    width: min(100%, 15.625rem);
  }
}
</style>
